export default [
  { value: 'Single', label: 'Single' },
  { value: 'Double Wide', label: 'Double Wide' },
];
